import { Inject, Injectable } from '@angular/core';
import { getId, skipHttpEvents } from '@cawita/core-front';
import { CwtApiService, mapApiDataItem, RequestConfig } from '@cawita/core-front/api';
import { map } from 'rxjs/operators';
import { Partner, Profile, User } from '@shared/models';
import { GenericCrudService, getCrudName } from '@shared/modules/crud';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProfileAPI {
    constructor(
        private api: CwtApiService,
        @Inject(getCrudName(User)) private userCrud: GenericCrudService<User>,
        @Inject(getCrudName(Profile)) private profileCrud: GenericCrudService<Profile>,
    ) { }

    public getLoggedUser(config?: RequestConfig) {
        return this.userCrud.getOne('logged', config);
    }

    public updateLoggedUserPicture(file?: File, config?: RequestConfig) {
        return this.api.patchFile(`user/logged/form-data`, {
            picture: file
        }, {
            ...(config ?? {}),
            responseType: 'json'
        }).pipe(
            skipHttpEvents(res => new User(res.body)),
        );
    }

    public getProfile(user: User | string, config?: RequestConfig) {
        return this.profileCrud.getAllNoPaginate({ user: getId(user) }, config).pipe(
            map(profiles => profiles[0] ?? null),
        );
    }

    public updateProfile(profileId: string, body: any, config?: RequestConfig) {
        return this.profileCrud.update(profileId, body, config);
    }

    public deleteProfile(profileId: string) {
        return this.profileCrud.delete(profileId);
    }

    public createProfileAndUser(profile): Observable<Profile> {
        return this.api.post(`profile/fromUser`, profile).pipe(mapApiDataItem(Profile));
    }

    public addProfileToBlockList(profileId: string, profileToBlock: Profile | string, config?: RequestConfig): Observable<Profile> {
        return this.api.patch(`profile/${getId(profileId)}/block`, { create: [getId(profileToBlock)] }, config).pipe(mapApiDataItem(Profile));
    }

    public removeProfileFromBlockList(profileId: string, profileToBlock: Profile | string, config?: RequestConfig): Observable<Profile> {
        return this.api.patch(`profile/${getId(profileId)}/block`, { delete: [getId(profileToBlock)] }, config).pipe(mapApiDataItem(Profile));
    }
}